import { Injectable } from '@angular/core';
import { GooglesheetService } from './googlesheet.service';
import { AnalyticsService } from './analytics.service';

@Injectable({
  providedIn: 'root'
})
export class MensajeWhatsappService {
  private data: { telefono: string, mensaje: string } | null = null;
  constructor(
    private sheetService: GooglesheetService,
    private analytics: AnalyticsService,
  ) {
    this.cargarDatos();
  }

  private cargarDatos() {
    this.sheetService.getSheetData('Configuraciones!B1:B4', 'config').subscribe({
      next: (data) => {
        const telefono = data.values[0][0];
        const mensaje = data.values[1];
        this.data = { telefono, mensaje };
      },
      error: (error) => {
        console.error('Error cargando datos de WhatsApp:', error);
      }
    });
  }

  enviarWhatsApp(mensajeUsuario: string = "") {
    const telefono = this.data?.telefono.replace(/\D/g, '') || '';
    const mensaje = mensajeUsuario !== "" ? mensajeUsuario : (this.data?.mensaje || '');
    const url = telefono
      ? `https://wa.me/${telefono}?text=${encodeURIComponent(mensaje)}`
      : '';

    // Registrar la intención aunque la configuración de WhatsApp todavía no
    // haya terminado de cargar.
    this.analytics.track('whatsapp_click', {
      link_url: url,
      link_text: mensajeUsuario ? 'Consulta desde producto' : 'Consulta general',
    });

    if (!this.data) {
      console.warn('Datos de WhatsApp no cargados aún');
      return;
    }

    window.open(url, '_blank'); // acción directa del usuario
  }

  abonar(linkPago:string){
    if (!linkPago) {
      console.warn('Datos de Pago no cargados aún');
      return;
    }
    window.open(linkPago, '_blank'); // acción directa del usuario
  }
}
